export default __webpack_public_path__ + "static/media/noSubjects.16302974.svg";